module.exports = __webpack_public_path__ + "img/456.5b3e54d2.png";